﻿import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
// Import our authentication service
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private auth: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (route.data != null) {
            return this.auth.user
                .then(x => this.auth.isAuthorized(route.data.roles))
                .then(this.authorize);
        }

        return this.auth.user
            .then(x => this.auth.authenticated)
            .then(this.authorize);

    }

    private authorize = (isAuthorized) => {
        if (isAuthorized) return true;

        this.router.navigate(['/401']);
        return false;
    }

}